import React, { DetailedHTMLProps, FormHTMLAttributes } from "react";

export type FormProps = Pick<
    DetailedHTMLProps<FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>,
    "onSubmit" | "children" | "style"
> & {
    testId?: string;
};

export const Form: React.FunctionComponent<FormProps> = (props: FormProps) => {
    return (
        <form onSubmit={props.onSubmit} style={props.style} data-testid={props.testId}>
            {props.children}
        </form>
    );
};
